import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { UserCheck, LogIn } from "lucide-react";

const ROLE_LABEL = { org_admin: "Organization Administrator", head_coach: "Head Coach", assistant_coach: "Assistant Coach", team_manager: "Team Manager", scorekeeper: "Scorekeeper", parent: "Parent", player: "Player" };

export default function RoleInviteAccept() {
  const { token } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [inv, setInv] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/live/role-invites/${token}`).then(({ data }) => setInv(data)).catch((e) => setError(e?.response?.data?.detail || "Invalid invite"));
  }, [token]);

  const accept = () => {
    setBusy(true);
    api.post(`/live/role-invites/${token}/accept`)
      .then(({ data }) => { toast.success(`You're now ${ROLE_LABEL[data.role] || data.role} for ${data.scope_name}`); navigate(data.slug ? `/live/teams/${data.slug}` : "/live"); })
      .catch((e) => toast.error(e?.response?.data?.detail || "Failed")).finally(() => setBusy(false));
  };

  return (
    <div className="min-h-screen bg-[#F1F3F6]"><Header />
      <div className="max-w-lg mx-auto px-6 py-16" data-testid="role-invite-page">
        <div className="bg-white border border-slate-200 rounded-sm p-8 text-center">
          {error ? <div data-testid="role-invite-error" className="text-sm text-[#E63946]">{error}</div>
            : !inv ? <div className="text-sm text-slate-400">Loading…</div> : (
              <>
                <div className="w-14 h-14 rounded-full bg-[#E63946]/10 grid place-items-center mx-auto"><UserCheck className="w-6 h-6 text-[#E63946]" /></div>
                <div className="label-overline text-[#E63946] mt-4">CBR Team Invite</div>
                <h1 className="font-display text-2xl uppercase tracking-tight mt-1" data-testid="role-invite-scope">{inv.scope_name}</h1>
                <p className="text-sm text-slate-500 mt-2">You've been invited as <b>{inv.role_label}</b>. Accepting adds this role to your CBR account.</p>
                {user ? (
                  <button data-testid="accept-role-btn" disabled={busy} onClick={accept} className="mt-6 w-full flex items-center justify-center gap-2 bg-[#E63946] text-white text-sm font-semibold uppercase tracking-wider py-3 rounded-sm hover:bg-[#c62f3b] disabled:opacity-50"><UserCheck className="w-4 h-4" /> Accept Role</button>
                ) : (
                  <div className="mt-6"><p className="text-xs text-slate-400 mb-2">Sign in or create an account to accept, then return here.</p>
                    <div className="flex gap-2">
                      <Link to="/login" data-testid="role-invite-login" className="flex-1 flex items-center justify-center gap-1.5 bg-[#0A192F] text-white text-sm font-semibold uppercase tracking-wider py-3 rounded-sm"><LogIn className="w-4 h-4" /> Sign In</Link>
                      <Link to="/signup" data-testid="role-invite-signup" className="flex-1 border border-slate-200 text-[#0A192F] text-sm font-semibold uppercase tracking-wider py-3 rounded-sm grid place-items-center">Create Account</Link>
                    </div>
                  </div>
                )}
              </>
            )}
        </div>
      </div>
    </div>
  );
}
